<template>
  <div class="section-header d-flex align-items-center">
    <i class="feather icon-more-vertical mr-2 section-handle"></i>

    <input
      class="form-control form-control-sm mr-2 section-title-input"
      v-model.trim="section.name"
      :placeholder="$t('risk.template.section_name')"
    />
    <span class="count-pill mr-2">
      ({{ totalCount }})
    </span>

    <b-button size="sm" class="mr-1" @click="$emit('toggle')">
      {{ section.collapsed ? $t('actions.expand') : $t('actions.collapse') }}
    </b-button>

    <b-button size="sm" variant="danger" class="mr-1" @click="$emit('remove')">
      {{ $t('actions.delete') }}
    </b-button>
    <b-button size="sm" variant="primary" title="Agregar subsección" @click="$emit('add-subsection')">
      +
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: { BButton },
  props: { section: { type: Object, required: true } },
  computed: {
    totalCount() {
      const root = (this.section && this.section.children && this.section.children.length) || 0;
      const subsArr = (this.section && this.section.subsections) ? this.section.subsections : [];
      const subs = subsArr.reduce((acc, s) => acc + ((s && s.children && s.children.length) || 0), 0);
      return root + subs;
    },
  },
};
</script>

<style scoped>
.section-header {
  background: #f7f7f7;
  border: 1px solid #ddd;
  padding: .35rem .5rem;
  border-radius: 6px;
}
.section-title-input { font-weight: 600; font-size: 15px; }
.section-handle { cursor: move; }
.count-pill { font-size: 12px; color: #555; }
</style>
